/* eslint-disable arrow-body-style */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {
  useState,
  useRef,
  useMemo,
  useEffect,
  useCallback,
  SetStateAction,
} from "react";
import {
  List,
  ListItem,
  ListItemText,
  Collapse,
  FormControl,
  FormControlLabel,
  Select,
  Typography,
  Checkbox,
} from "@material-ui/core";
import { ExpandLess, ExpandMore, FilterList, KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
// import { User, Queue } from "./DashboardPage";
import CxSidebarView from "./CxSidebarView";
import {
  CXAgent,
  CXAgentGroup,
  CXQueue,
  CXQueueGroup,
  CXSupervisor,
} from "./CxDashboard";
import ActiveFilterView from "./timeline/ActiveFilterView";
import newUi from './styles/Sidebar.module.css';
import { sidebarDescAscStyleHandler } from "./Hud";
import RcButton from "./UiUtilities/Button";

function setsAreDifferent(setA: Set<string>, setB: Set<string>) {
  return (
    setA.size !== setB.size || Array.from(setA).some((item) => !setB.has(item))
  );
}

const setCxStorageConfiguration = (storedString: string, storedValue: any) =>
  localStorage.setItem(storedString, JSON.stringify(storedValue));

export default function CxSidebar({
  mode,
  users = [],
  queues,
  agentGroups,
  queueGroups,
  departments,
  supervisors,
  sites,
  sortAgents,
  sortQueues,
  sortAgentGroups,
  sortQueueGroups,
  sortSupervisors,
  sortDepartments,
  sortSites,
  blockedUsers,
  blockedQueues,
  blockedAgentGroups,
  blockedQueueGroups,
  blockedDepartments,
  blockedSupervisors,
  blockedSites,
  excludedUsers,
  excludedQueues,
  excludedAgentGroups,
  excludedQueueGroups,
  excludedDepartments,
  excludedSupervisors,
  excludedSites,
  userSortField,
  userSortOrder,
  queueSortField,
  queueSortOrder,
  agentGroupSortOrder,
  queueGroupSortOrder,
  departmentSortOrder,
  supervisorSortField,
  supervisorSortOrder,
  siteSortOrder,
  setBlockedUsers,
  setBlockedQueues,
  setBlockedAgentGroups,
  setBlockedQueueGroups,
  setBlockedDepartments,
  setBlockedSupervisors,
  setBlockedSites,
  setExcludedUsers,
  setExcludedQueues,
  setExcludedAgentGroups,
  setExcludedQueueGroups,
  setExcludedDepartments,
  setExcludedSupervisors,
  setExcludedSites,
  setUserSortField,
  setUserSortOrder,
  setQueueSortField,
  setQueueSortOrder,
  setAgentGroupSortOrder,
  setQueueGroupSortOrder,
  setDepartmentSortOrder,
  setSupervisorSortField,
  setSupervisorSortOrder,
  setSiteSortOrder,
  showNoQueues,
  setShowNoQueues,
  showAgentType,
  showSupervisorType,
  setShowAgentType,
  setShowSupervisorType,
  showUnsupervised,
  setShowUnsupervised,
  displayPortraits,
  setDisplayPortraits,
  organizationId,
  activeFilterRef,
  page,
  showAvailable,
  setShowAvailable,
  showAway,
  showOffline,
  showWorking,
  showTraining,
  showEngaged,
  showTransition,
  showRna,
  showBreakAfterCall,
  showUnknown,
  showPendingDisp,
  showOnBreak,
  showLunch,
  setShowOffline,
  setShowAway,
  setShowTraining,
  setShowWorking,
  setShowPendingDisp,
  setShowEngaged,
  setShowTransition,
  setShowLunch,
  setShowOnBreak,
  setShowRna,
  setShowBreakAfterCall,
  setShowUnknown
}: {
  showAvailable: boolean;
  showAway: boolean;
  showOffline: boolean;
  showWorking: boolean;
  showTraining: boolean;
  showEngaged: boolean;
  showTransition: boolean;
  showRna: boolean;
  showBreakAfterCall: boolean;
  showUnknown: boolean;
  showPendingDisp: boolean;
  showLunch: boolean;
  showOnBreak: boolean;
  setShowAvailable: React.Dispatch<SetStateAction<boolean>>;
  setShowOffline: React.Dispatch<SetStateAction<boolean>>;
  setShowAway: React.Dispatch<SetStateAction<boolean>>;
  setShowTraining: React.Dispatch<SetStateAction<boolean>>;
  setShowWorking: React.Dispatch<SetStateAction<boolean>>;
  setShowPendingDisp: React.Dispatch<SetStateAction<boolean>>;
  setShowEngaged: React.Dispatch<SetStateAction<boolean>>;
  setShowTransition: React.Dispatch<SetStateAction<boolean>>;
  setShowRna: React.Dispatch<SetStateAction<boolean>>;
  setShowBreakAfterCall: React.Dispatch<SetStateAction<boolean>>;
  setShowUnknown: React.Dispatch<SetStateAction<boolean>>;
  setShowOnBreak: React.Dispatch<SetStateAction<boolean>>;
  setShowLunch: React.Dispatch<SetStateAction<boolean>>;
  organizationId: string;
  activeFilterRef: any;
  page: string;
  mode: string;
  users: CXAgent[] | undefined;
  queues: CXQueue[];
  agentGroups: Array<CXAgentGroup>;
  queueGroups: Array<CXQueueGroup>;
  departments: Array<{ id: string; name: string }>;
  supervisors: Array<CXSupervisor>;
  sites: Array<{ id: string; name: string }>;
  sortAgents: (arg: any) => Array<any>;
  sortQueues: (arg: any) => Array<any>;
  sortAgentGroups: (arg: Array<any>) => Array<any>;
  sortQueueGroups: (arg: Array<any>) => Array<any>;
  sortSupervisors: (arg: Array<any>) => Array<any>;
  sortDepartments: (arg: Array<any>) => Array<any>;
  sortSites: (arg: Array<any>) => Array<any>;
  blockedUsers: Set<string>;
  blockedQueues: Set<string>;
  blockedAgentGroups: Set<string>;
  blockedQueueGroups: Set<string>;
  blockedDepartments: Set<string>;
  blockedSupervisors: Set<string>;
  blockedSites: Set<string>;
  excludedUsers: Set<string>;
  excludedQueues: Set<string>;
  excludedAgentGroups: Set<string>;
  excludedQueueGroups: Set<string>;
  excludedDepartments: Set<string>;
  excludedSupervisors: Set<string>;
  excludedSites: Set<string>;
  setBlockedUsers: React.Dispatch<React.SetStateAction<Set<string>>>;
  setBlockedQueues: React.Dispatch<React.SetStateAction<Set<string>>>;
  setBlockedAgentGroups: React.Dispatch<React.SetStateAction<Set<string>>>;
  setBlockedQueueGroups: React.Dispatch<React.SetStateAction<Set<string>>>;
  setBlockedDepartments: React.Dispatch<React.SetStateAction<Set<string>>>;
  setBlockedSupervisors: React.Dispatch<React.SetStateAction<Set<string>>>;
  setBlockedSites: React.Dispatch<React.SetStateAction<Set<string>>>;
  setExcludedUsers: React.Dispatch<React.SetStateAction<Set<string>>>;
  setExcludedQueues: React.Dispatch<React.SetStateAction<Set<string>>>;
  setExcludedAgentGroups: React.Dispatch<React.SetStateAction<Set<string>>>;
  setExcludedQueueGroups: React.Dispatch<React.SetStateAction<Set<string>>>;
  setExcludedDepartments: React.Dispatch<React.SetStateAction<Set<string>>>;
  setExcludedSupervisors: React.Dispatch<React.SetStateAction<Set<string>>>;
  setExcludedSites: React.Dispatch<React.SetStateAction<Set<string>>>;
  userSortField: string;
  userSortOrder: 1 | -1;
  queueSortField: string;
  queueSortOrder: 1 | -1;
  agentGroupSortOrder: 1 | -1;
  queueGroupSortOrder: 1 | -1;
  departmentSortOrder: 1 | -1;
  supervisorSortField: string;
  supervisorSortOrder: 1 | -1;
  siteSortOrder: 1 | -1;
  setUserSortField: React.Dispatch<React.SetStateAction<string>>;
  setUserSortOrder: React.Dispatch<React.SetStateAction<1 | -1>>;
  setQueueSortField: React.Dispatch<React.SetStateAction<string>>;
  setQueueSortOrder: React.Dispatch<React.SetStateAction<1 | -1>>;
  setAgentGroupSortOrder: React.Dispatch<React.SetStateAction<1 | -1>>;
  setQueueGroupSortOrder: React.Dispatch<React.SetStateAction<1 | -1>>;
  setDepartmentSortOrder: React.Dispatch<React.SetStateAction<1 | -1>>;
  setSupervisorSortField: React.Dispatch<React.SetStateAction<string>>;
  setSupervisorSortOrder: React.Dispatch<React.SetStateAction<1 | -1>>;
  setSiteSortOrder: React.Dispatch<React.SetStateAction<1 | -1>>;
  showNoQueues: boolean;
  setShowNoQueues: React.Dispatch<React.SetStateAction<boolean>>;
  showAgentType: boolean;
  showSupervisorType: boolean;
  setShowAgentType: React.Dispatch<React.SetStateAction<boolean>>;
  setShowSupervisorType: React.Dispatch<React.SetStateAction<boolean>>;
  showUnsupervised: boolean;
  setShowUnsupervised: React.Dispatch<React.SetStateAction<boolean>>;
  displayPortraits: boolean;
  setDisplayPortraits: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const [openList, setOpenList] = useState<
    | "presenceFilters"
    | "users"
    | "queues"
    | "agentGroups"
    | "queueGroups"
    | "departments"
    | "supervisors"
    | "sites"
    | ""
  >("");
  const [expandedStatuses, setExpandedStatuses] = useState<"busy" | "unavailable" | "offline" | undefined>(undefined)

  const clickOnShowAgents = useCallback(
    (event: any) => {
      const show = event.target.checked;
      const newExcludedUsers = new Set(excludedUsers);

      users.forEach((u) => {
        if (u.agentType === "AGENT") {
          if (show) newExcludedUsers.delete(u.id);
          if (!show) newExcludedUsers.add(u.id);
        }
      });

      if (setsAreDifferent(newExcludedUsers, excludedUsers)) {
        setExcludedUsers(newExcludedUsers);
      }
      console.log("cx excluded from click event: ", newExcludedUsers);
      setShowAgentType(show);
      setCxStorageConfiguration(
        "cx-excluded-agents",
        Array.from(newExcludedUsers)
      );
      setCxStorageConfiguration("cx-show-agent-type", JSON.stringify(show));
    },
    [excludedUsers, setExcludedUsers, setShowAgentType, users]
  );

  const clickOnShowSupervisors = useCallback(
    (event: any) => {
      const show = event.target.checked;

      const newExcludedUsers = new Set(excludedUsers);

      users.forEach((u) => {
        if (u.agentType === "SUPERVISOR") {
          if (show) newExcludedUsers.delete(u.id);
          if (!show) newExcludedUsers.add(u.id);
        }
      });

      if (setsAreDifferent(newExcludedUsers, excludedUsers)) {
        setExcludedUsers(newExcludedUsers);
      }

      setShowSupervisorType(show);
      setCxStorageConfiguration(
        "cx-excluded-agents",
        JSON.stringify(Array.from(newExcludedUsers))
      );
      setCxStorageConfiguration(
        "cx-show-supervisor-type",
        JSON.stringify(show)
      );
    },
    [excludedUsers, setExcludedUsers, setShowSupervisorType, users]
  );

  const clickOnShowUnsupervised = useCallback(
    (event: any) => {
      const show = event.target.checked;

      const newExcludedUsers = new Set(excludedUsers);

      users.forEach((u) => {
        if (!u.supervisors || u.supervisors.length === 0) {
          if (show) newExcludedUsers.delete(u.id);
          if (!show) newExcludedUsers.add(u.id);
        }
      });

      if (setsAreDifferent(newExcludedUsers, excludedUsers)) {
        setExcludedUsers(newExcludedUsers);
      }

      setShowUnsupervised(show);
      setCxStorageConfiguration(
        "cx-excluded-agents",
        JSON.stringify(Array.from(newExcludedUsers))
      );
      setCxStorageConfiguration("cx-show-unsupervised", JSON.stringify(show));
    },
    [excludedUsers, setExcludedUsers, setShowUnsupervised, users]
  );

  const clickOnUser = useCallback(
    (user: CXAgent) => {
      if (excludedUsers === undefined) {
        return;
      }
      const newExcludedUsers = new Set(excludedUsers);

      if (newExcludedUsers.has(user.id)) {
        newExcludedUsers.delete(user.id);
      } else {
        newExcludedUsers.add(user.id);
      }
      if (setsAreDifferent(newExcludedUsers, excludedUsers)) {
        setExcludedUsers(newExcludedUsers);
      }
      setCxStorageConfiguration(
        "cx-excluded-agents",
        Array.from(newExcludedUsers)
      );
    },
    [excludedUsers, setExcludedUsers]
  );

  const clickOnQueue = useCallback(
    (queue: CXQueue) => {
      if (excludedQueues === undefined) {
        return;
      }
      const newExcludedUsers = new Set(excludedUsers);
      const newExcludedQueues = new Set(excludedQueues);

      const queueIsExcluded = newExcludedQueues.has(queue.id);

      if (queueIsExcluded) {
        newExcludedQueues.delete(queue.id);
        queue.assignedAgents?.forEach((agentId) => {
          newExcludedUsers.delete(agentId.toString());
        });
      } else {
        newExcludedQueues.add(queue.id);
        // only add agents if no other non-excluded queues contain them
        queue.assignedAgents?.forEach((agentId) => {
          const agentExcluded = newExcludedUsers.has(agentId.toString());
          const agentInOtherQueue = queues.some(
            (myQueue) =>
              myQueue.id !== queue.id &&
              !newExcludedQueues.has(myQueue.id) &&
              myQueue.assignedAgents?.find(
                (id) => id.toString() === agentId.toString()
              )
          );
          if (!agentExcluded && !agentInOtherQueue) {
            newExcludedUsers.add(agentId.toString());
          }
        });
      }

      if (setsAreDifferent(excludedQueues, newExcludedQueues)) {
        setExcludedQueues(newExcludedQueues);
      }

      if (setsAreDifferent(excludedUsers, newExcludedUsers)) {
        setExcludedUsers(newExcludedUsers);
      }
      setCxStorageConfiguration(
        "cx-excluded-agents",
        Array.from(newExcludedUsers)
      );
      setCxStorageConfiguration(
        "cx-excluded-queues",
        Array.from(newExcludedQueues)
      );
    },
    [excludedQueues, excludedUsers, queues, setExcludedUsers, setExcludedQueues]
  );

  const clickOnAgentGroup = useCallback(
    (group: CXAgentGroup) => {
      if (excludedAgentGroups === undefined) {
        return;
      }
      const newExcludedUsers = new Set(excludedUsers);
      const newExcludedAgentGroups = new Set(excludedAgentGroups);

      const agentGroupIsExcluded = newExcludedAgentGroups.has(group.id);

      if (agentGroupIsExcluded) {
        newExcludedAgentGroups.delete(group.id);
        group.agents?.forEach((agentId) => {
          newExcludedUsers.delete(agentId.toString());
        });
      } else {
        newExcludedAgentGroups.add(group.id);
        // only add agents if no other non-excluded queues contain them
        group.agents?.forEach((agentId) => {
          const agentExcluded = newExcludedUsers.has(agentId.toString());
          const agentInOtherAgentGroup = agentGroups.some(
            (myAgentGroup) =>
              myAgentGroup.id !== group.id &&
              !newExcludedAgentGroups.has(myAgentGroup.id) &&
              myAgentGroup.agents?.find(
                (id) => id.toString() === agentId.toString()
              )
          );
          if (!agentExcluded && !agentInOtherAgentGroup) {
            newExcludedUsers.add(agentId.toString());
          }
        });
      }

      if (setsAreDifferent(excludedAgentGroups, newExcludedAgentGroups)) {
        setExcludedAgentGroups(newExcludedAgentGroups);
      }

      if (setsAreDifferent(excludedUsers, newExcludedUsers)) {
        setExcludedUsers(newExcludedUsers);
      }

      setCxStorageConfiguration(
        "cx-excluded-agents",
        Array.from(newExcludedUsers)
      );
      setCxStorageConfiguration(
        "cx-excluded-agent-groups",
        Array.from(newExcludedAgentGroups)
      );
    },
    [
      agentGroups,
      excludedAgentGroups,
      excludedUsers,
      setExcludedAgentGroups,
      setExcludedUsers,
    ]
  );

  const clickOnDepartment = useCallback(
    (dept: { id: string; name: string }) => {
      const newExcludedUsers = new Set(excludedUsers);
      const newExcludedDepartments = new Set(excludedDepartments);

      const deptExcluded = newExcludedDepartments.has(dept.id);

      if (deptExcluded) {
        newExcludedDepartments.delete(dept.id);
        users.forEach((user) => {
          if (user.department === dept.id) {
            newExcludedUsers.delete(user.id);
          }
        });
      } else {
        newExcludedDepartments.add(dept.id);
        users.forEach((user) => {
          if (user.department === dept.id) {
            newExcludedUsers.add(user.id);
          }
        });
      }

      if (setsAreDifferent(excludedDepartments, newExcludedDepartments)) {
        setExcludedDepartments(newExcludedDepartments);
      }

      if (setsAreDifferent(excludedUsers, newExcludedUsers)) {
        setExcludedUsers(newExcludedUsers);
      }

      setCxStorageConfiguration(
        "cx-excluded-agents",
        Array.from(newExcludedUsers)
      );
      setCxStorageConfiguration(
        "cx-excluded-departments",
        Array.from(newExcludedDepartments)
      );
    },
    [
      excludedDepartments,
      excludedUsers,
      departments,
      setExcludedUsers,
      setExcludedDepartments,
    ]
  );

  const clickOnSite = useCallback(
    (site: { id: string; name: string }) => {
      const newExcludedUsers = new Set(excludedUsers);
      const newExcludedSites = new Set(excludedSites);

      const siteExcluded = newExcludedSites.has(site.id);

      if (siteExcluded) {
        newExcludedSites.delete(site.id);
        users.forEach((user) => {
          if (user.site === site.id) {
            newExcludedUsers.delete(user.id);
          }
        });
      } else {
        newExcludedSites.add(site.id);
        users.forEach((user) => {
          if (user.site === site.id) {
            newExcludedUsers.add(user.id);
          }
        });
      }

      if (setsAreDifferent(excludedSites, newExcludedSites)) {
        setExcludedSites(newExcludedSites);
      }

      if (setsAreDifferent(excludedUsers, newExcludedUsers)) {
        setExcludedUsers(newExcludedUsers);
      }
      setCxStorageConfiguration(
        "cx-excluded-agents",
        Array.from(newExcludedUsers)
      );
      setCxStorageConfiguration(
        "cx-excluded-sites",
        Array.from(newExcludedSites)
      );
    },
    [excludedSites, excludedUsers, sites, setExcludedUsers, setExcludedSites]
  );

  const clickOnQueueGroup = useCallback(
    (queueGroup: CXQueueGroup) => {
      const newExcludedQueueGroups = new Set(excludedQueueGroups);
      const newExcludedUsers = new Set(excludedUsers);
      const newExcludedQueues = new Set(excludedQueues);

      const queueGroupIsExcluded = newExcludedQueueGroups.has(queueGroup.id);

      if (queueGroupIsExcluded) {
        newExcludedQueueGroups.delete(queueGroup.id);
        queueGroup.queues?.forEach((queueId) => {
          newExcludedQueues.delete(queueId.toString());
        });
        queueGroup.agents?.forEach((agentId) => {
          newExcludedUsers.delete(agentId.toString());
        });
      } else {
        newExcludedQueueGroups.add(queueGroup.id);
        // add queues
        queueGroup.queues.forEach((queueId) => {
          newExcludedQueues.add(queueId.toString());
        });
        // only add agents if no other non-excluded queues contain them
        queueGroup.agents?.forEach((agentId) => {
          const agentExcluded = newExcludedUsers.has(agentId.toString());
          const agentInOtherQueueGroup = queueGroups.some(
            (myQueueGroup) =>
              myQueueGroup.id !== queueGroup.id &&
              !newExcludedQueueGroups.has(myQueueGroup.id) &&
              myQueueGroup.agents?.find(
                (id) => id.toString() === agentId.toString()
              )
          );
          if (!agentExcluded && !agentInOtherQueueGroup) {
            newExcludedUsers.add(agentId.toString());
          }
        });
      }

      if (setsAreDifferent(excludedQueueGroups, newExcludedQueueGroups)) {
        setExcludedQueueGroups(newExcludedQueueGroups);
      }

      if (setsAreDifferent(excludedQueues, newExcludedQueues)) {
        setExcludedQueues(newExcludedQueues);
      }

      if (setsAreDifferent(excludedUsers, newExcludedUsers)) {
        setExcludedUsers(newExcludedUsers);
      }
      setCxStorageConfiguration(
        "cx-excluded-agents",
        Array.from(newExcludedUsers)
      );
      setCxStorageConfiguration(
        "cx-excluded-queue-groups",
        Array.from(newExcludedQueueGroups)
      );
      setCxStorageConfiguration(
        "cx-excluded-queues",
        Array.from(newExcludedQueues)
      );
    },
    [
      excludedQueueGroups,
      excludedQueues,
      excludedUsers,
      queueGroups,
      setExcludedQueueGroups,
      setExcludedQueues,
      setExcludedUsers,
    ]
  );

  const onAllUsers = useCallback(() => {
    const newExcludedUsers = new Set(blockedUsers);

    if (setsAreDifferent(newExcludedUsers, excludedUsers)) {
      setExcludedUsers(newExcludedUsers);
    }
    setCxStorageConfiguration(
      "cx-excluded-agents",
      Array.from(newExcludedUsers)
    );
  }, [excludedUsers, blockedUsers, setExcludedUsers]);

  const onNoneUsers = useCallback(() => {
    const newExcludedUsers = new Set(users.map((user) => user.id));

    if (setsAreDifferent(newExcludedUsers, excludedUsers)) {
      setExcludedUsers(newExcludedUsers);
    }
    setCxStorageConfiguration(
      "cx-excluded-agents",
      Array.from(newExcludedUsers)
    );
  }, [excludedUsers, users, setExcludedUsers]);

  const onAllQueues = useCallback(() => {
    const newExcludedQueues = new Set(blockedQueues);
    const newExcludedUsers = new Set(blockedUsers);

    queues.forEach((myQueue) => {
      if (blockedQueues.has(myQueue.id)) {
        myQueue.assignedAgents?.forEach((userId) => {
          if (
            queues.every(
              (queue) =>
                queue.id === myQueue.id ||
                excludedQueues.has(queue.id) ||
                !queue.assignedAgents?.some(
                  (agentId) => agentId.toString() === userId.toString()
                )
            )
          ) {
            newExcludedUsers.add(userId.toString());
          }
        });
      }
    });

    if (setsAreDifferent(excludedQueues, newExcludedQueues)) {
      setExcludedQueues(newExcludedQueues);
    }

    if (setsAreDifferent(excludedUsers, newExcludedUsers)) {
      setExcludedUsers(newExcludedUsers);
    }

    setCxStorageConfiguration(
      "cx-excluded-queues",
      Array.from(newExcludedQueues)
    );
    setCxStorageConfiguration(
      "cx-excluded-agents",
      Array.from(newExcludedUsers)
    );
  }, [
    queues,
    blockedUsers,
    blockedQueues,
    excludedQueues,
    excludedUsers,
    setExcludedQueues,
    setExcludedUsers,
  ]);

  const onNoneQueues = useCallback(() => {
    const newExcludedQueues = new Set(queues.map((queue) => queue.id));
    const newExcludedUsers = new Set(excludedUsers);

    queues.forEach((myQueue) => {
      if (newExcludedQueues.has(myQueue.id)) {
        myQueue.assignedAgents?.forEach((userId) => {
          if (
            queues.every(
              (queue) =>
                queue.id === myQueue.id ||
                newExcludedQueues.has(queue.id) ||
                !queue.assignedAgents?.some(
                  (agentId) => agentId.toString() === userId.toString()
                )
            )
          ) {
            newExcludedUsers.add(userId.toString());
          }
        });
      }
    });

    if (setsAreDifferent(excludedQueues, newExcludedQueues)) {
      setExcludedQueues(newExcludedQueues);
    }

    if (setsAreDifferent(excludedUsers, newExcludedUsers)) {
      setExcludedUsers(newExcludedUsers);
    }

    setCxStorageConfiguration(
      "cx-excluded-queues",
      Array.from(newExcludedQueues)
    );
    setCxStorageConfiguration(
      "cx-excluded-agents",
      Array.from(newExcludedUsers)
    );
  }, [
    queues,
    excludedQueues,
    excludedUsers,
    setExcludedQueues,
    setExcludedUsers,
  ]);

  const onAllDepartments = useCallback(() => {
    const newExcludedDepartments = new Set(blockedDepartments);
    const newExcludedUsers = new Set(blockedUsers);

    users
      .filter((u) => !newExcludedUsers.has(u.id))
      .forEach((myUser) => {
        if (
          myUser.department &&
          newExcludedDepartments.has(myUser.department)
        ) {
          newExcludedUsers.add(myUser.id);
        }
      });

    if (setsAreDifferent(excludedDepartments, newExcludedDepartments)) {
      setExcludedDepartments(newExcludedDepartments);
    }

    if (setsAreDifferent(excludedUsers, newExcludedUsers)) {
      setExcludedUsers(newExcludedUsers);
    }

    setCxStorageConfiguration(
      "cx-excluded-agents",
      Array.from(newExcludedUsers)
    );
    setCxStorageConfiguration(
      "cx-excluded-departments",
      Array.from(newExcludedDepartments)
    );
  }, [
    users,
    blockedUsers,
    blockedDepartments,
    excludedDepartments,
    excludedUsers,
    setExcludedDepartments,
    setExcludedUsers,
  ]);

  const onAllSites = useCallback(() => {
    const newExcludedSites = new Set(blockedSites);
    const newExcludedUsers = new Set(blockedUsers);

    users
      .filter((u) => !newExcludedUsers.has(u.id))
      .forEach((myUser) => {
        if (myUser.site && newExcludedSites.has(myUser.site)) {
          newExcludedUsers.add(myUser.id);
        }
      });

    if (setsAreDifferent(excludedSites, newExcludedSites)) {
      setExcludedSites(newExcludedSites);
    }

    if (setsAreDifferent(excludedUsers, newExcludedUsers)) {
      setExcludedUsers(newExcludedUsers);
    }

    setCxStorageConfiguration(
      "cx-excluded-agents",
      Array.from(newExcludedUsers)
    );
    setCxStorageConfiguration(
      "cx-excluded-sites",
      Array.from(newExcludedSites)
    );
  }, [
    users,
    blockedUsers,
    blockedSites,
    excludedSites,
    excludedUsers,
    setExcludedSites,
    setExcludedUsers,
  ]);

  const onNoneDepartments = useCallback(() => {
    const newExcludedDepartments = new Set(departments.map((dept) => dept.id));
    const newExcludedUsers = new Set(excludedUsers);

    users.forEach((u) => {
      if (u.department) {
        newExcludedUsers.add(u.id);
      }
    });

    if (setsAreDifferent(excludedDepartments, newExcludedDepartments)) {
      setExcludedDepartments(newExcludedDepartments);
    }

    if (setsAreDifferent(excludedUsers, newExcludedUsers)) {
      setExcludedUsers(newExcludedUsers);
    }

    setCxStorageConfiguration(
      "cx-excluded-agents",
      Array.from(newExcludedUsers)
    );
    setCxStorageConfiguration(
      "cx-excluded-departments",
      Array.from(newExcludedDepartments)
    );
  }, [
    users,
    excludedDepartments,
    excludedUsers,
    setExcludedDepartments,
    setExcludedUsers,
  ]);

  const onNoneSites = useCallback(() => {
    const newExcludedSites = new Set(sites.map((s) => s.id));
    const newExcludedUsers = new Set(excludedUsers);

    users.forEach((u) => {
      if (u.site) {
        newExcludedUsers.add(u.id);
      }
    });

    if (setsAreDifferent(excludedSites, newExcludedSites)) {
      setExcludedSites(newExcludedSites);
    }

    if (setsAreDifferent(excludedUsers, newExcludedUsers)) {
      setExcludedUsers(newExcludedUsers);
    }

    setCxStorageConfiguration(
      "cx-excluded-agents",
      Array.from(newExcludedUsers)
    );
    setCxStorageConfiguration(
      "cx-excluded-sites",
      Array.from(newExcludedSites)
    );
  }, [users, excludedSites, excludedUsers, setExcludedSites, setExcludedUsers]);

  const onAllAgentGroups = useCallback(() => {
    const newExcludedAgentGroups = new Set(blockedAgentGroups);
    const newExcludedUsers = new Set(blockedUsers);
    users
      .filter((u) => !newExcludedUsers.has(u.id))
      .forEach((myUser) => {
        if (
          myUser.groupId &&
          newExcludedAgentGroups.has(myUser.groupId.toString())
        ) {
          newExcludedUsers.add(myUser.id);
        }
      });

    if (setsAreDifferent(excludedAgentGroups, newExcludedAgentGroups)) {
      setExcludedAgentGroups(newExcludedAgentGroups);
    }

    if (setsAreDifferent(excludedUsers, newExcludedUsers)) {
      setExcludedUsers(newExcludedUsers);
    }

    setCxStorageConfiguration(
      "cx-excluded-agents",
      Array.from(newExcludedUsers)
    );
    setCxStorageConfiguration(
      "cx-excluded-agent-groups",
      Array.from(newExcludedAgentGroups)
    );
  }, [
    agentGroups,
    users,
    blockedAgentGroups,
    blockedUsers,
    excludedAgentGroups,
    excludedUsers,
    setExcludedAgentGroups,
    setExcludedUsers,
  ]);

  const onNoneAgentGroups = useCallback(() => {
    const newExcludedAgentGroups = new Set(agentGroups.map((gr) => gr.id));
    const newExcludedUsers = new Set(excludedUsers);

    agentGroups.forEach((myGroup) => {
      if (newExcludedAgentGroups.has(myGroup.id)) {
        myGroup.agents?.forEach((userId) => {
          if (
            agentGroups.every(
              (group) =>
                group.id === myGroup.id ||
                newExcludedAgentGroups.has(group.id) ||
                !group.agents?.some(
                  (agentId) => agentId.toString() === userId.toString()
                )
            )
          ) {
            newExcludedUsers.add(userId.toString());
          }
        });
      }
    });

    if (setsAreDifferent(excludedAgentGroups, newExcludedAgentGroups)) {
      setExcludedAgentGroups(newExcludedAgentGroups);
    }

    if (setsAreDifferent(excludedUsers, newExcludedUsers)) {
      setExcludedUsers(newExcludedUsers);
    }

    setCxStorageConfiguration(
      "cx-excluded-agents",
      Array.from(newExcludedUsers)
    );
    setCxStorageConfiguration(
      "cx-excluded-agent-groups",
      Array.from(newExcludedAgentGroups)
    );
  }, [
    agentGroups,
    excludedAgentGroups,
    excludedUsers,
    setExcludedAgentGroups,
    setExcludedUsers,
  ]);

  const onAllQueueGroups = useCallback(() => {
    const newExcludedQueueGroups = new Set(blockedQueueGroups);
    const newExcludedQueues = new Set(blockedQueues);
    const newExcludedUsers = new Set(blockedUsers);

    queueGroups.forEach((myQueueGroup) => {
      if (blockedQueueGroups.has(myQueueGroup.id)) {
        myQueueGroup.queues?.forEach((queueId) => {
          if (
            queueGroups.every(
              (queueGroup) =>
                queueGroup.id === myQueueGroup.id ||
                excludedQueueGroups.has(queueGroup.id) ||
                !queueGroup.agents?.some(
                  (agentId) => agentId.toString() === queueId.toString()
                )
            )
          ) {
            newExcludedQueues.add(queueId.toString());
          }
        });
        myQueueGroup.agents?.forEach((userId) => {
          if (
            queueGroups.every(
              (queueGroup) =>
                queueGroup.id === myQueueGroup.id ||
                excludedQueueGroups.has(queueGroup.id) ||
                !queueGroup.agents?.some(
                  (agentId) => agentId.toString() === userId.toString()
                )
            )
          ) {
            newExcludedUsers.add(userId.toString());
          }
        });
      }
    });

    if (setsAreDifferent(excludedQueueGroups, newExcludedQueueGroups)) {
      setExcludedQueueGroups(newExcludedQueueGroups);
    }

    if (setsAreDifferent(excludedQueues, newExcludedQueues)) {
      setExcludedQueues(newExcludedQueues);
    }

    if (setsAreDifferent(excludedUsers, newExcludedUsers)) {
      setExcludedUsers(newExcludedUsers);
    }
    setCxStorageConfiguration(
      "cx-excluded-agents",
      Array.from(newExcludedUsers)
    );
    setCxStorageConfiguration(
      "cx-excluded-queue-groups",
      Array.from(newExcludedQueueGroups)
    );
    setCxStorageConfiguration(
      "cx-excluded-queues",
      Array.from(newExcludedQueues)
    );
  }, [
    blockedQueueGroups,
    blockedQueues,
    blockedUsers,
    excludedQueueGroups,
    excludedQueues,
    excludedUsers,
    queueGroups,
    setExcludedQueueGroups,
    setExcludedQueues,
    setExcludedUsers,
  ]);

  const onNoneQueueGroups = useCallback(() => {
    const newExcludedQueueGroups = new Set(
      queueGroups.map((queueGroup) => queueGroup.id)
    );
    const newExcludedQueues = new Set(excludedQueues);
    const newExcludedUsers = new Set(excludedUsers);

    queueGroups.forEach((myQueueGroup) => {
      if (newExcludedQueueGroups.has(myQueueGroup.id)) {
        myQueueGroup.agents?.forEach((userId) => {
          if (
            queueGroups.every(
              (queueGroup) =>
                queueGroup.id === myQueueGroup.id ||
                newExcludedQueueGroups.has(queueGroup.id) ||
                !queueGroup.agents?.some(
                  (agentId) => agentId.toString() === userId.toString()
                )
            )
          ) {
            newExcludedUsers.add(userId.toString());
          }
        });
        myQueueGroup.queues?.forEach((queueId) => {
          if (
            queueGroups.every(
              (queueGroup) =>
                queueGroup.id === myQueueGroup.id ||
                newExcludedQueueGroups.has(queueGroup.id) ||
                !queueGroup.queues?.some(
                  (agentId) => agentId.toString() === queueId.toString()
                )
            )
          ) {
            newExcludedQueues.add(queueId.toString());
          }
        });
      }
    });

    if (setsAreDifferent(excludedQueues, newExcludedQueues)) {
      setExcludedQueues(newExcludedQueues);
    }

    if (setsAreDifferent(excludedUsers, newExcludedUsers)) {
      setExcludedUsers(newExcludedUsers);
    }

    setCxStorageConfiguration(
      "cx-excluded-agents",
      Array.from(newExcludedUsers)
    );
    setCxStorageConfiguration(
      "cx-excluded-queue-groups",
      Array.from(newExcludedQueueGroups)
    );
    setCxStorageConfiguration(
      "cx-excluded-queues",
      Array.from(newExcludedQueues)
    );
  }, [
    queueGroups,
    excludedQueues,
    excludedUsers,
    setExcludedQueues,
    setExcludedUsers,
  ]);

  const clickOnSupervisor = useCallback(
    (supervisor: CXSupervisor) => {
      const newExcludedUsers = new Set(excludedUsers);
      const newExcludedSupervisors = new Set(excludedSupervisors);

      const supervisorIsExcluded = newExcludedSupervisors.has(supervisor.id);

      if (supervisorIsExcluded) {
        newExcludedSupervisors.delete(supervisor.id);
        supervisor.agents?.forEach((agentId) => {
          newExcludedUsers.delete(agentId.toString());
        });
      } else {
        newExcludedSupervisors.add(supervisor.id);
        // only add agents if no other non-excluded queues contain them
        supervisor.agents?.forEach((agentId) => {
          const agentExcluded = newExcludedUsers.has(agentId.toString());
          const agentUnderOtherSupervisor = supervisors.some(
            (mySuper) =>
              mySuper.id !== supervisor.id &&
              !newExcludedSupervisors.has(mySuper.id) &&
              mySuper.agents?.find((id) => id.toString() === agentId.toString())
          );
          if (!agentExcluded && !agentUnderOtherSupervisor) {
            newExcludedUsers.add(agentId.toString());
          }
        });
      }

      if (setsAreDifferent(excludedSupervisors, newExcludedSupervisors)) {
        setExcludedSupervisors(newExcludedSupervisors);
      }

      if (setsAreDifferent(excludedUsers, newExcludedUsers)) {
        setExcludedUsers(newExcludedUsers);
      }
      setCxStorageConfiguration(
        "cx-excluded-agents",
        Array.from(newExcludedUsers)
      );
      setCxStorageConfiguration(
        "cx-excluded-supervisors",
        Array.from(newExcludedSupervisors)
      );
    },
    [
      excludedSupervisors,
      excludedUsers,
      setExcludedSupervisors,
      setExcludedUsers,
      supervisors,
    ]
  );

  const onAllSupervisors = useCallback(() => {
    const newExcludedSupervisors = new Set(blockedSupervisors);
    const newExcludedUsers = new Set(blockedUsers);

    supervisors.forEach((mySuper) => {
      if (blockedSupervisors.has(mySuper.id)) {
        mySuper.agents?.forEach((userId) => {
          if (
            supervisors.every(
              (supervisor) =>
                supervisor.id === mySuper.id ||
                excludedSupervisors.has(supervisor.id) ||
                !supervisor.agents?.some(
                  (agentId) => agentId.toString() === userId.toString()
                )
            )
          ) {
            newExcludedUsers.add(userId.toString());
          }
        });
      }
    });

    if (setsAreDifferent(excludedSupervisors, newExcludedSupervisors)) {
      setExcludedSupervisors(newExcludedSupervisors);
    }

    if (setsAreDifferent(excludedUsers, newExcludedUsers)) {
      setExcludedUsers(newExcludedUsers);
    }
    setCxStorageConfiguration(
      "cx-excluded-agents",
      Array.from(newExcludedUsers)
    );
    setCxStorageConfiguration(
      "cx-excluded-supervisors",
      Array.from(newExcludedSupervisors)
    );
  }, [
    blockedSupervisors,
    blockedUsers,
    excludedSupervisors,
    excludedUsers,
    setExcludedSupervisors,
    setExcludedUsers,
    supervisors,
  ]);

  const onNoneSupervisors = useCallback(() => {
    const newExcludedSupervisors = new Set(supervisors.map((s) => s.id));
    const newExcludedUsers = new Set(excludedUsers);

    supervisors.forEach((mySuper) => {
      if (newExcludedSupervisors.has(mySuper.id)) {
        mySuper.agents?.forEach((userId) => {
          if (
            supervisors.every(
              (supervisor) =>
                supervisor.id === mySuper.id ||
                newExcludedSupervisors.has(supervisor.id) ||
                !supervisor.agents?.some(
                  (agentId) => agentId.toString() === userId.toString()
                )
            )
          ) {
            newExcludedUsers.add(userId.toString());
          }
        });
      }
    });

    if (setsAreDifferent(excludedSupervisors, newExcludedSupervisors)) {
      setExcludedSupervisors(newExcludedSupervisors);
    }

    if (setsAreDifferent(excludedUsers, newExcludedUsers)) {
      setExcludedUsers(newExcludedUsers);
    }
    setCxStorageConfiguration(
      "cx-excluded-agents",
      Array.from(newExcludedUsers)
    );
    setCxStorageConfiguration(
      "cx-excluded-supervisors",
      Array.from(newExcludedSupervisors)
    );
  }, [
    excludedSupervisors,
    excludedUsers,
    setExcludedSupervisors,
    setExcludedUsers,
    supervisors,
  ]);

  useEffect(() => {
    if (organizationId) {
      // checkbox values for states
      const availableFromStorage = localStorage.getItem("show-available")
      const engagedFromStorage = localStorage.getItem(`show-engaged`) 
      const breakAfterCallFromStorage = localStorage.getItem(`show-break-after-call`) 
      const transitionFromStorage = localStorage.getItem(`show-transition`) 
      const pendingDispFromStorage = localStorage.getItem(`show-pending-disp`) 
      const onBreakFromStorage = localStorage.getItem(`show-on-break`)  
      const awayFromStorage = localStorage.getItem(`show-away`) 
      const lunchFromStorage = localStorage.getItem(`show-lunch`)
      const trainingFromStorage = localStorage.getItem(`show-training`) 
      const workingFromStorage =localStorage.getItem(`show-working`) 
      const rnaFromStorage = localStorage.getItem(`show-rna`) 
      const offlineFromStorage = localStorage.getItem(`show-offline`) 
      const unknownFromStorage = localStorage.getItem(`show-unknown`)

      // apply stored values if present
      if (availableFromStorage) setShowAvailable(JSON.parse(availableFromStorage))
      if (engagedFromStorage) setShowEngaged(JSON.parse(engagedFromStorage))
      if (breakAfterCallFromStorage) setShowBreakAfterCall(JSON.parse(breakAfterCallFromStorage))
      if (transitionFromStorage) setShowTransition(JSON.parse(transitionFromStorage))
      if (pendingDispFromStorage) setShowPendingDisp(JSON.parse(pendingDispFromStorage))
      if (onBreakFromStorage) setShowOnBreak(JSON.parse(onBreakFromStorage))
      if (awayFromStorage) setShowAway(JSON.parse(awayFromStorage))
      if (lunchFromStorage) setShowLunch(JSON.parse(lunchFromStorage))
      if (trainingFromStorage) setShowTraining(JSON.parse(trainingFromStorage))
      if (workingFromStorage) setShowWorking(JSON.parse(workingFromStorage))
      if (rnaFromStorage) setShowRna(JSON.parse(rnaFromStorage))
      if (offlineFromStorage) setShowOffline(JSON.parse(offlineFromStorage))
      if (unknownFromStorage) setShowUnknown(JSON.parse(unknownFromStorage))
         
      // if not, default them to checked
      if (!availableFromStorage) localStorage.setItem(`show-available`, "true")
      if (!engagedFromStorage) localStorage.setItem(`show-engaged`, "true") 
      if (!breakAfterCallFromStorage) localStorage.setItem(`show-break-after-call`, "true") 
      if (!transitionFromStorage) localStorage.setItem(`show-transition`, "true") 
      if (!pendingDispFromStorage) localStorage.setItem(`show-pending-disp`, "true") 
      if (!onBreakFromStorage) localStorage.setItem(`show-on-break`, "true") 
      if (!awayFromStorage) localStorage.setItem(`show-away`, "true") 
      if (!lunchFromStorage) localStorage.setItem(`show-lunch`, "true")
      if (!trainingFromStorage) localStorage.setItem(`show-training`, "true") 
      if (!workingFromStorage) localStorage.setItem(`show-working`, "true") 
      if (!rnaFromStorage)  localStorage.setItem(`show-rna`, "true") 
      if (!offlineFromStorage) localStorage.setItem(`show-offline`, "true") 
      if (!unknownFromStorage) localStorage.setItem(`show-unknown`, "true")
    }

  }, [organizationId])

  const setCXFilters = (filter: string, setting: boolean) => {
    if (filter === 'engaged') {
      if (!setting) {
        localStorage.setItem("show-engaged", JSON.stringify(false))
        localStorage.setItem("show-break-after-call", JSON.stringify(false))
        localStorage.setItem("show-transition", JSON.stringify(false))
        localStorage.setItem("show-pending-disp", JSON.stringify(false))
      }
      if (setting) {
        localStorage.setItem("show-engaged", JSON.stringify(true))
        localStorage.setItem("show-break-after-call", JSON.stringify(true))
        localStorage.setItem("show-transition", JSON.stringify(true))
        localStorage.setItem("show-pending-disp", JSON.stringify(true))
      }
    }
    if (filter === 'unavailable') {
      if (!setting) {
        localStorage.setItem("show-on-break", JSON.stringify(false))
        localStorage.setItem("show-away", JSON.stringify(false))
        localStorage.setItem("show-lunch", JSON.stringify(false))
        localStorage.setItem("show-training", JSON.stringify(false))
        localStorage.setItem("show-working", JSON.stringify(false))
        localStorage.setItem("show-rna", JSON.stringify(false))
      }
      if (setting) {
        localStorage.setItem("show-on-break", JSON.stringify(true))
        localStorage.setItem("show-away", JSON.stringify(true))
        localStorage.setItem("show-lunch", JSON.stringify(true))
        localStorage.setItem("show-training", JSON.stringify(true))
        localStorage.setItem("show-working", JSON.stringify(true))
        localStorage.setItem("show-rna", JSON.stringify(true))
      }
    }
    if (filter === 'offline') {
      if (!setting) {
        localStorage.setItem("show-offline", JSON.stringify(false))
        localStorage.setItem("show-unknown", JSON.stringify(false))
      }
      if (setting) {
        localStorage.setItem("show-offline", JSON.stringify(true))
        localStorage.setItem("show-unknown", JSON.stringify(true))
      }
    }
  }

  return (
    <div>
      <List component="div" disablePadding style={{ marginBottom: 40 }}>
        <ListItem className="sidebar-command" onClick={() => setOpenList((old) => old === "presenceFilters" ? "" : 'presenceFilters')}>
           <ListItemText primary="Presence Filters" />
            {showAvailable && showAway && showBreakAfterCall && showEngaged && showLunch && showOffline && showOnBreak && showPendingDisp && showRna && showTraining && showTransition && showUnknown && showWorking ? <></> : <FilterList fontSize="small" style={{color: 'white'}} />}
            {openList === "presenceFilters" ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openList === 'presenceFilters'}timeout="auto" unmountOnExit>
        {/* agent presence statuses */}
              <div className={newUi.checkboxContainer} style={{background: mode === 'light' ? "#378ccd" :  "#242424"}}>
                {/*  AVAILABLE  */}
                <div className={newUi.sidebarFormRowCheckbox}>
                  <Checkbox
                    id="available-checkbox"
                    color="default"
                    checked={showAvailable}
                    onClick={() => {
                      localStorage.setItem('show-available', JSON.stringify(!showAvailable))
                      setShowAvailable((p: any) => !p)}}
                    style={{ color: "white", width: 20, height: 20 }} /> 
                  <label htmlFor="available-checkbox" className={newUi.sidebarOptionLabel}>Available</label>
                </div>
                {/* BUSY */}
                <div className={newUi.sidebarFormRowCheckboxWithDropdown}>
                 <span>
                 <Checkbox 
                    id="busy-handler-checkbox"
                    color="default"
                    indeterminate={
                      !(showEngaged && showBreakAfterCall && showTransition && showPendingDisp) && 
                      (showEngaged || showBreakAfterCall || showTransition || showPendingDisp)}
                    checked={showEngaged && showBreakAfterCall && showTransition && showPendingDisp}
                    onClick={() => {
                      if (showEngaged && showBreakAfterCall && showTransition && showPendingDisp) {
                        setShowEngaged(false)
                        setShowBreakAfterCall(false)
                        setShowTransition(false)
                        setShowPendingDisp(false)
                        setCXFilters("engaged", false)
                        
                       
                      }
                      if (!showEngaged || !showBreakAfterCall || !showTransition || !showPendingDisp) {
                        setShowEngaged(true)
                        setShowBreakAfterCall(true)
                        setShowTransition(true)
                        setShowPendingDisp(true)
                        setCXFilters("engaged", true)
                      }
                    }}
                    style={{ color: "white", width: 20, height: 20 }}/> 
                  <label htmlFor="busy-handler-checkbox" className={newUi.sidebarOptionLabel}>Engaged</label>
                 </span>
                  <div className={newUi.sidebarFormRowCheckboxToggle}>
                    <RcButton style={{color: "white"}} onClick={() => setExpandedStatuses((p) => p === "busy" ? undefined : 'busy')}>
                       {expandedStatuses === "busy" ? <ExpandLess /> : <ExpandMore />}
                    </RcButton>
                  </div>
                </div>
                <Collapse in={expandedStatuses === 'busy'}>
                    {[{key: 'engaged', setter: setShowEngaged, getter: showEngaged, lsKey: "show-engaged"},
                      {key: "break after call", setter: setShowBreakAfterCall, getter: showBreakAfterCall, lsKey: "show-break-after-call"},
                      {key: 'transition', setter: setShowTransition, getter: showTransition, lsKey: "show-transition"},
                      {key: "pending disposition", setter: setShowPendingDisp, getter: showPendingDisp, lsKey: "show-pending-disp"}
                    ].map(({key, getter, setter, lsKey}) => (
                      <div style={{marginLeft: 40}}>
                        <Checkbox 
                          id={`${key.replace(" ", "-")}-checkbox`}
                          color="default"
                          checked={getter}
                          onClick={() => {
                            localStorage.setItem(lsKey, JSON.stringify(!getter))
                            setter((p => !p))
                          }}
                          style={{ color: "white", width: 20, height: 20 }}/> 
                        <label htmlFor={`${key.replace(" ", "-")}-checkbox`} className={newUi.sidebarOptionLabel}>{key}</label>
                      </div>
                    ))}
                  </Collapse>
                  {/* UNAVAILABLE */}
                  <div className={newUi.sidebarFormRowCheckboxWithDropdown}>
                 <span>
                 <Checkbox 
                    id="unavailable-handler-checkbox"
                    color="default"
                    indeterminate={
                     !(showOnBreak && showAway && showLunch && showTraining && showWorking && showRna)
                     && (showOnBreak || showAway || showLunch || showTraining || showWorking || showRna)}
                    checked={showOnBreak && showAway && showLunch && showTraining && showWorking && showRna}
                    onClick={() => {
                      if (showOnBreak && showAway && showLunch && showTraining && showWorking && showRna) {
                        setShowOnBreak(false)
                        setShowAway(false)
                        setShowLunch(false)
                        setShowTraining(false)
                        setShowWorking(false)
                        setShowRna(false)
                        setCXFilters("unavailable", false)
                      }
                      if (!showOnBreak || !showAway || !showLunch || !showTraining || !showWorking || !showRna) {
                        setShowOnBreak(true)
                        setShowAway(true)
                        setShowLunch(true)
                        setShowTraining(true)
                        setShowWorking(true)
                        setShowRna(true)
                        setCXFilters("unavailable", true)
                      }
                    }}
                    style={{ color: "white", width: 20, height: 20 }}/> 
                  <label htmlFor="unavailable-handler-checkbox" className={newUi.sidebarOptionLabel}>Unavailable</label>
                 </span>
                  <div className={newUi.sidebarFormRowCheckboxToggle}>
                    <RcButton style={{color: "white"}} onClick={() => setExpandedStatuses((p) => p === "unavailable" ? undefined : 'unavailable')}>
                       {expandedStatuses === "unavailable" ? <ExpandLess /> : <ExpandMore />}
                    </RcButton>
                  </div>
                </div>
                <Collapse in={expandedStatuses === 'unavailable'}>
                    {[{key: 'on break', setter: setShowOnBreak, getter: showOnBreak, lsKey: "show-on-break"},
                      {key: "away", setter: setShowAway, getter: showAway, lsKey: "show-away"},
                      {key: 'lunch', setter: setShowLunch, getter: showLunch, lsKey: "show-lunch"},
                      {key: "training", setter: setShowTraining, getter: showTraining, lsKey: "show-training"},
                      {key: "working", setter: setShowWorking, getter: showWorking, lsKey: "show-working"},
                      {key: "rna state", setter: setShowRna, getter: showRna, lsKey: "show-rna"}

                    ].map(({key, getter, setter, lsKey}) => (
                      <div style={{marginLeft: 40}}>
                        <Checkbox 
                          id={`${key.replace(" ", "-")}-checkbox`}
                          color="default"
                          checked={getter}
                          onClick={() => {
                            localStorage.setItem(lsKey, JSON.stringify(!getter))
                            setter((p => !p))
                          }}
                          style={{ color: "white", width: 20, height: 20 }}/> 
                        <label htmlFor={`${key.replace(" ", "-")}-checkbox`} className={newUi.sidebarOptionLabel}>{key}</label>
                      </div>
                    ))}
                  </Collapse>
                  {/* OFFLINE / UNKNOWN */}
                  <div className={newUi.sidebarFormRowCheckboxWithDropdown}>
                 <span>
                 <Checkbox 
                    id="offline-handler-checkbox"
                    color="default"
                    indeterminate={
                      !((showOffline && showUnknown)) 
                      && (showOffline || showUnknown)}
                     checked={showOffline && showUnknown}
                    onClick={() => {
                      if (showOffline && showUnknown) {
                        setShowOffline(false)
                        setShowUnknown(false)
                        setCXFilters('offline', false)
                      }
                      if (!showOffline || !showUnknown) {
                        setShowOffline(true)
                        setShowUnknown(true)
                        setCXFilters('offline', true)
                      }
                    }}
                    style={{ color: "white", width: 20, height: 20 }}/> 
                  <label htmlFor="offline-handler-checkbox" className={newUi.sidebarOptionLabel}>Offline</label>
                 </span>
                  <div className={newUi.sidebarFormRowCheckboxToggle}>
                    <RcButton style={{color: "white"}} onClick={() => setExpandedStatuses((p) => p === "offline" ? undefined : 'offline')}>
                       {expandedStatuses === "offline" ? <ExpandLess /> : <ExpandMore />}
                    </RcButton>
                  </div>
                </div>
                <Collapse in={expandedStatuses === 'offline'}>
                    {[{key: 'offline', setter: setShowOffline, getter: showOffline, lsKey: "show-offline"},
                      {key: "unknown", setter: setShowUnknown, getter: showUnknown, lsKey: "show-unknown"},
                    ].map(({key, getter, setter, lsKey}) => (
                      <div style={{marginLeft: 40}}>
                        <Checkbox 
                          id={`${key.replace(" ", "-")}-checkbox`}
                          color="default"
                          checked={getter}
                          onClick={() => {
                            localStorage.setItem(lsKey, JSON.stringify(!getter))
                            setter((p => !p))}}
                          style={{ color: "white", width: 20, height: 20 }}/> 
                        <label htmlFor={`${key.replace(" ", "-")}-checkbox`} className={newUi.sidebarOptionLabel}>{key}</label>
                      </div>
                    ))}
                  </Collapse>
                {/* <div className={newUi.sidebarFormRowCheckbox}>
                  <Checkbox 
                  id="dnd-checkbox"
                    color="default"
                    checked={showDnd}
                    onClick={() => setShowDnd((p: any) => !p)}
                    style={{ color: "white", width: 20, height: 20 }}/> 
                  <label htmlFor="dnd-checkbox" className={newUi.sidebarOptionLabel}>DND</label>
                </div>
                <div className={newUi.sidebarFormRowCheckbox}>
                  <Checkbox
                  id="invisible-checkbox"
                    color="default"
                    checked={showInvisible}
                    onClick={() => setShowInvisible((p: any) => !p)}
                    style={{ color: "white", width: 20, height: 20 }} /> 
                  <label htmlFor="invisible-checkbox" className={newUi.sidebarOptionLabel}>Invisible</label>
                </div> */}
              </div>
        </Collapse>
        <ListItem
          className="sidebar-command"
          onClick={() =>
            setOpenList((oldOpen) => (oldOpen === "users" ? "" : "users"))
          }
        >
          <ListItemText primary="Agents" />
          {!blockedUsers.size && !excludedUsers.size  ? <></> : <FilterList fontSize="small" style={{color: 'white'}} />}
          {openList === "users" ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse
          style={{ cursor: "pointer" }}
          in={openList === "users"}
          timeout="auto"
          unmountOnExit
        >
          <List
            component="div"
            disablePadding
            // className="cx-sidebar-view-container"
          >
             <ListItem>
              <FormControl>
                <FormControlLabel
                  control={
                    <Checkbox
                      style={{ color: "white" }}
                      defaultChecked={showAgentType}
                      onChange={clickOnShowAgents}
                    />
                  }
                  label="Show Agents"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      style={{ color: "white" }}
                      defaultChecked={showSupervisorType}
                      onChange={clickOnShowSupervisors}
                    />
                  }
                  label="Show Supervisors"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      style={{ color: "white" }}
                      defaultChecked={displayPortraits}
                      onChange={() => {
                        setDisplayPortraits(() => !displayPortraits);
                        localStorage.setItem(
                          "cx-display-portraits",
                          JSON.stringify(!displayPortraits)
                        );
                      }}
                    />
                  }
                  label="Show Portraits"
                />
              </FormControl>
            </ListItem>
            <div className={newUi.sidebarFormRowDropdown}>
              <div style={{width: "100%"}}>
                <span className={newUi.sidebarOptionLabel}>Sort Field</span>
                <select onChange={(event) => setUserSortField(event.target.value as string)} className={mode === 'light' ? newUi.sidebarDropdown : newUi.sidebarDropdownDark} id="user-display-label" value={userSortField}>
                  <option value="first-name">First Name</option>
                  <option value="last-name">Last Name</option>
                  <option value="state">State</option>
                </select>
              </div>
              <div className={newUi.ascDescButtonContainer} style={{display: 'flex', flex: 1, justifyContent: 'end'}}>
                <button type="button" className={newUi.ascDescButton} style={{...sidebarDescAscStyleHandler(mode === 'light'), marginLeft: 10}} onClick={() => setUserSortOrder((prev) => prev === 1 ? -1 : 1)} >
                  {userSortOrder === 1 ? "asc" : "desc"}
                  {userSortOrder === 1 ? <KeyboardArrowUp style={{color: mode === 'light' ? "black" :  "white"}} fontSize="small"  /> : <KeyboardArrowDown style={{color: mode === 'light' ? "black":  "white"}} fontSize="small"  />}
                </button>
              </div>
            </div>
           
            <CxSidebarView
              mode={mode}
              itemList={users}
              formatDisplay={(user: CXAgent) =>
                `${user.firstName || ""} ${user.lastName || ""}`
              }
              sortFunction={sortAgents}
              searchAttributes={["firstName", "lastName"]}
              excludedItems={excludedUsers}
              blockedItems={blockedUsers}
              setBlockedItems={setBlockedUsers}
              onItemClick={(user: CXAgent) => clickOnUser(user)}
              onAll={onAllUsers}
              onNone={onNoneUsers}
            />
          </List>
        </Collapse>
        <ListItem
          className="sidebar-command"
          onClick={() =>
            setOpenList((oldOpen) =>
              oldOpen === "agentGroups" ? "" : "agentGroups"
            )
          }
        >
          <ListItemText primary="Agent Groups" />
          {!blockedAgentGroups.size && !excludedAgentGroups.size  ? <></> : <FilterList fontSize="small" style={{color: 'white'}} />}
          {openList === "agentGroups" ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse
          style={{ cursor: "pointer" }}
          in={openList === "agentGroups"}
          timeout="auto"
          unmountOnExit
        >
          <List
            component="div"
            disablePadding
            // className="cx-sidebar-view-container"
          >
            <ListItem>
              <div
                className="cx-sort-select"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  gap: 8,
                }}
              >
                <FormControl
                  className="cx-form-container"
                  variant="outlined"
                  style={{
                    display: "none",
                  }}
                >
                  <FormControlLabel
                    className="cx-label"
                    style={{
                      margin: 0,
                    }}
                    control={
                      <Select
                        style={{
                          background: "white",
                          color: "black",
                          border: "1px solid black",
                          width: "100%",
                        }}
                        className="cx-selector"
                        native
                        fullWidth
                        value="Name"
                        // onChange={(event) =>
                        //   setUserSortField(event.target.value)
                        // }
                      >
                        <option value="name"> Group Name</option>
                      </Select>
                    }
                    label="Sort Field"
                    labelPlacement="top"
                  />
                </FormControl>
                <FormControl
                  className="cx-form-container"
                  variant="outlined"
                  style={{
                    width: "100%",
                    display: "none",
                  }}
                >
                  <FormControlLabel
                    style={{
                      margin: 0,
                    }}
                    control={
                      <Select
                        style={{
                          background: "white",
                          color: "black",
                          border: "1px solid black",
                          width: "100%",
                        }}
                        native
                        value={agentGroupSortOrder === 1 ? "asc" : "desc"}
                        onChange={(event) =>
                          event.target.value === "asc"
                            ? setAgentGroupSortOrder(1)
                            : setAgentGroupSortOrder(-1)
                        }
                      >
                        <option value="asc">Ascending</option>
                        <option value="desc">Descending</option>
                      </Select>
                    }
                    label="Sort Direction"
                    labelPlacement="top"
                  />
                </FormControl>
              </div>
            </ListItem>

            <CxSidebarView
              itemList={agentGroups}
              formatDisplay={(agentGroup: CXAgentGroup) =>
                agentGroup.groupName || ""
              }
              sortFunction={sortAgentGroups}
              searchAttributes={["groupName"]}
              excludedItems={excludedAgentGroups}
              blockedItems={blockedAgentGroups}
              setBlockedItems={setBlockedAgentGroups}
              onItemClick={(group: CXAgentGroup) => clickOnAgentGroup(group)}
              onAll={onAllAgentGroups}
              onNone={onNoneAgentGroups}
              mode={mode}
            />
          </List>
        </Collapse>
        <ListItem
          className="sidebar-command"
          onClick={() =>
            setOpenList((oldOpen) => (oldOpen === "queues" ? "" : "queues"))
          }
        >
          <ListItemText primary="Queues" />
          {!blockedQueues.size && !excludedQueues.size  ? <></> : <FilterList fontSize="small" style={{color: 'white'}} />}
          {openList === "queues" ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse
          style={{ cursor: "pointer" }}
          in={openList === "queues"}
          timeout="auto"
          unmountOnExit
        >
          <List
            component="div"
            disablePadding
            // className="cx-sidebar-view-container"
          >
            <ListItem>
              <div
                className="cx-sort-select"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  gap: 8,
                }}
              >
                <FormControl
                  className="cx-form-container"
                  variant="outlined"
                  style={{
                    display: "none",
                  }}
                >
                  <FormControlLabel
                    style={{
                      margin: 0,
                    }}
                    control={
                      <Select
                        // readOnly
                        style={{
                          background: "white",
                          color: "black",
                          border: "1px solid black",
                          width: "100%",
                        }}
                        native
                        fullWidth
                        value={queueSortField}
                        onChange={(event) =>
                          setQueueSortField(event.target.value as string)
                        }
                      >
                        <option value="name">Name</option>
                        {/* <option value="type">Type</option> */}
                      </Select>
                    }
                    label="Sort Field"
                    labelPlacement="top"
                  />
                </FormControl>
                <FormControl
                  className="cx-form-container"
                  variant="outlined"
                  style={{
                    margin: 0,
                    width: "100%",
                    display: "none",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Select
                        native
                        fullWidth
                        style={{
                          background: "white",
                          color: "black",
                          border: "1px solid black",
                          width: "100%",
                        }}
                        value={queueSortOrder === 1 ? "asc" : "desc"}
                        onChange={(event) =>
                          event.target.value === "asc"
                            ? setQueueSortOrder(1)
                            : setQueueSortOrder(-1)
                        }
                      >
                        <option value="asc">Ascending</option>
                        <option value="desc">Descending</option>
                      </Select>
                    }
                    label="Sort Direction"
                    labelPlacement="top"
                  />
                </FormControl>
              </div>
            </ListItem>
            <ListItem
              style={{ padding: 0 }}
              onClick={() => {
                setShowNoQueues(!showNoQueues);
                setCxStorageConfiguration(
                  "cx-show-queue-agents",
                  !showNoQueues
                );
              }}
            >
              <Checkbox
                color="default"
                style={{ color: "white" }}
                checked={showNoQueues}
              />
              <ListItemText primary="Show no queues agents" />
            </ListItem>
            <CxSidebarView
              mode={mode}
              itemList={queues}
              formatDisplay={(queue: CXQueue) => queue.gateName || ""}
              sortFunction={sortQueues}
              searchAttributes={["gateName"]}
              onAll={onAllQueues}
              onNone={onNoneQueues}
              excludedItems={excludedQueues}
              blockedItems={blockedQueues}
              setBlockedItems={setBlockedQueues}
              onItemClick={(queue) => clickOnQueue(queue)}
            />
          </List>
        </Collapse>
        <ListItem
          className="sidebar-command"
          onClick={() =>
            setOpenList((oldOpen) =>
              oldOpen === "queueGroups" ? "" : "queueGroups"
            )
          }
        >
          <ListItemText primary="Queue Groups" />
          {!blockedAgentGroups.size && !excludedAgentGroups.size  ? <></> : <FilterList fontSize="small" style={{color: 'white'}} />}
          {openList === "queueGroups" ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse
          style={{ cursor: "pointer" }}
          in={openList === "queueGroups"}
          timeout="auto"
          unmountOnExit
        >
          <List
            component="div"
            disablePadding
            // className="cx-sidebar-view-container"
          >
            <ListItem>
              <div
                className="cx-sort-select"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  gap: 8,
                }}
              >
                <FormControl
                  className="cx-form-container"
                  variant="outlined"
                  style={{
                    display: "none",
                  }}
                >
                  <FormControlLabel
                    style={{
                      margin: 0,
                    }}
                    control={
                      <Select
                        style={{
                          background: "white",
                          color: "black",
                          border: "1px solid black",
                          width: "100%",
                        }}
                        native
                        fullWidth
                        value="Name"
                        // onChange={(event) =>
                        //   setUserSortField(event.target.value)
                        // }
                      >
                        <option value="name"> Group Name</option>
                      </Select>
                    }
                    label="Sort Field"
                    labelPlacement="top"
                  />
                </FormControl>
                <FormControl
                  className="cx-form-container"
                  variant="outlined"
                  style={{
                    width: "100%",
                    display: "none",
                  }}
                >
                  <FormControlLabel
                    style={{
                      margin: 0,
                    }}
                    control={
                      <Select
                        style={{
                          background: "white",
                          color: "black",
                          border: "1px solid black",
                          width: "100%",
                        }}
                        native
                        value={queueGroupSortOrder === 1 ? "asc" : "desc"}
                        onChange={(event) =>
                          event.target.value === "asc"
                            ? setQueueGroupSortOrder(1)
                            : setQueueGroupSortOrder(-1)
                        }
                      >
                        <option value="asc">Ascending</option>
                        <option value="desc">Descending</option>
                      </Select>
                    }
                    label="Sort Direction"
                    labelPlacement="top"
                  />
                </FormControl>
              </div>
            </ListItem>
            <CxSidebarView
              itemList={queueGroups}
              formatDisplay={(queueGroup: CXQueueGroup) =>
                queueGroup.groupName || ""
              }
              sortFunction={sortQueueGroups}
              searchAttributes={["groupName"]}
              excludedItems={excludedQueueGroups}
              blockedItems={blockedQueueGroups}
              setBlockedItems={setBlockedQueueGroups}
              onItemClick={(group: CXQueueGroup) => clickOnQueueGroup(group)}
              onAll={onAllQueueGroups}
              onNone={onNoneQueueGroups}
              mode={mode}
            />
          </List>
        </Collapse>
        <ListItem
          className="sidebar-command"
          onClick={() =>
            setOpenList((oldOpen) =>
              oldOpen === "departments" ? "" : "departments"
            )
          }
        >
          <ListItemText primary="Departments" />
          {!blockedDepartments.size && !excludedDepartments.size  ? <></> : <FilterList fontSize="small" style={{color: 'white'}} />}
          {openList === "departments" ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openList === "departments"} timeout="auto" unmountOnExit>
          <List
            component="div"
            disablePadding
            // className="cx-sidebar-view-container"
          >
            <ListItem>
              <div
                className="cx-sort-select"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                }}
              >
                <FormControl
                  className="cx-form-container"
                  variant="outlined"
                  style={{
                    width: "100%",
                    display: "none",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Select
                        style={{
                          background: "white",
                          color: "black",
                          border: "1px solid black",
                          width: "100%",
                        }}
                        native
                        value={departmentSortOrder === 1 ? "asc" : "desc"}
                        onChange={(event) =>
                          event.target.value === "asc"
                            ? setDepartmentSortOrder(1)
                            : setDepartmentSortOrder(-1)
                        }
                      >
                        <option value="asc">Ascending</option>
                        <option value="desc">Descending</option>
                      </Select>
                    }
                    label="Sort Direction"
                    labelPlacement="top"
                  />
                </FormControl>
              </div>
            </ListItem>

            <CxSidebarView
              itemList={departments}
              formatDisplay={(dept: { id: string; name: string }) =>
                dept.name || ""
              }
              sortFunction={sortDepartments}
              searchAttributes={["name"]}
              excludedItems={excludedDepartments}
              blockedItems={blockedDepartments}
              setBlockedItems={setBlockedDepartments}
              onItemClick={(dept: { id: string; name: string }) =>
                clickOnDepartment(dept)
              }
              onAll={onAllDepartments}
              onNone={onNoneDepartments}
              mode={mode}
            />
          </List>
        </Collapse>
        <ListItem
          onClick={() =>
            setOpenList((oldOpen) =>
              oldOpen === "supervisors" ? "" : "supervisors"
            )
          }
        >
          <ListItemText primary="Supervisors" />
          {!blockedSupervisors.size && !excludedSupervisors.size  ? <></> : <FilterList fontSize="small" style={{color: 'white'}} />}
          {openList === "supervisors" ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse
          style={{ cursor: "pointer" }}
          in={openList === "supervisors"}
          timeout="auto"
          unmountOnExit
        >
          <List
            component="div"
            disablePadding
            // className="cx-sidebar-view-container"
          >
            <ListItem>
              <FormControl>
                <FormControlLabel
                  control={
                    <Checkbox
                      style={{ color: "white" }}
                      defaultChecked={showUnsupervised}
                      onChange={clickOnShowUnsupervised}
                    />
                  }
                  label="Show unsupervised agents"
                />
              </FormControl>
            </ListItem>
            <ListItem>
              <div
                className="cx-sort-select"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  gap: 8,
                }}
              >
                <FormControl
                  size="small"
                  className="cx-form-container"
                  variant="outlined"
                >
                  <FormControlLabel
                    style={{
                      margin: 0,
                      display: "none",
                    }}
                    control={
                      <Select
                        native
                        fullWidth
                        value={supervisorSortField}
                        onChange={(event) =>
                          setSupervisorSortField(event.target.value as string)
                        }
                        style={{
                          background: "white",
                          color: "black",
                          border: "1px solid black",
                          width: "100%",
                        }}
                      >
                        <option value="first-name">First Name</option>
                        <option value="last-name">Last Name</option>
                      </Select>
                    }
                    label="Sort Field"
                    labelPlacement="top"
                  />
                </FormControl>
                <FormControl
                  size="small"
                  className="cx-form-container"
                  variant="outlined"
                >
                  <FormControlLabel
                    style={{
                      margin: 0,
                      display: "none",
                    }}
                    control={
                      <Select
                        style={{
                          background: "white",
                          color: "black",
                          border: "1px solid black",
                          width: "100%",
                        }}
                        native
                        value={supervisorSortOrder === 1 ? "asc" : "desc"}
                        onChange={(event) =>
                          event.target.value === "asc"
                            ? setSupervisorSortOrder(1)
                            : setSupervisorSortOrder(-1)
                        }
                      >
                        <option value="asc">Ascending</option>
                        <option value="desc">Descending</option>
                      </Select>
                    }
                    label="Sort Direction"
                    labelPlacement="top"
                  />
                </FormControl>
              </div>
            </ListItem>
            <CxSidebarView
              mode={mode}
              itemList={supervisors}
              formatDisplay={(user: CXSupervisor) =>
                `${user.firstName || ""} ${user.lastName || ""}`
              }
              sortFunction={sortSupervisors}
              searchAttributes={["firstName", "lastName"]}
              excludedItems={excludedSupervisors}
              blockedItems={blockedSupervisors}
              setBlockedItems={setBlockedSupervisors}
              onItemClick={(user) => clickOnSupervisor(user)}
              onAll={onAllSupervisors}
              onNone={onNoneSupervisors}
            />
          </List>
        </Collapse>
        <ListItem
          className="sidebar-command"
          onClick={() =>
            setOpenList((oldOpen) => (oldOpen === "sites" ? "" : "sites"))
          }
        >
          <ListItemText primary="Sites" />
          {!blockedSites.size && !excludedSites.size  ? <></> : <FilterList fontSize="small" style={{color: 'white'}} />}
          {openList === "sites" ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openList === "sites"} timeout="auto" unmountOnExit>
          <List
            component="div"
            disablePadding
            // className="cx-sidebar-view-container"
          >
            <ListItem>
              <div
                className="cx-sort-select"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                }}
              >
                <FormControl
                  className="cx-form-container"
                  variant="outlined"
                  style={{
                    width: "100%",
                    display: "none",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Select
                        style={{
                          background: "white",
                          color: "black",
                          border: "1px solid black",
                          width: "100%",
                        }}
                        native
                        value={siteSortOrder === 1 ? "asc" : "desc"}
                        onChange={(event) =>
                          event.target.value === "asc"
                            ? setSiteSortOrder(1)
                            : setSiteSortOrder(-1)
                        }
                      >
                        <option value="asc">Ascending</option>
                        <option value="desc">Descending</option>
                      </Select>
                    }
                    label="Sort Direction"
                    labelPlacement="top"
                  />
                </FormControl>
              </div>
            </ListItem>

            <CxSidebarView
              itemList={sites}
              formatDisplay={(s: { id: string; name: string }) => s.name || ""}
              sortFunction={sortSites}
              searchAttributes={["name"]}
              excludedItems={excludedSites}
              blockedItems={blockedSites}
              setBlockedItems={setBlockedSites}
              onItemClick={(s: { id: string; name: string }) => clickOnSite(s)}
              onAll={onAllSites}
              onNone={onNoneSites}
              mode={mode}
            />
          </List>
        </Collapse>
        <div style={{paddingBottom: 110}} />
        {/* {
         organizationId === "3154756020" && <ActiveFilterView orgId={organizationId} typeOfDisplay={page} filterRef={activeFilterRef} mode={mode} />
        } */}
      </List>
      
    </div>
  );
}
